import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const RepresentantesPage = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    pueblo: '',
    experiencia: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6rmdrkddmmni7ck8vag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          pueblo: '',
          experiencia: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              Programa de Representantes
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Gana comisiones compartiendo productos de IslaVende. Es fácil, rápido y sin inversión inicial.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <div className="relative w-full h-96">
                <img
                  src="https://public.readdy.ai/ai/img_res/90bca6d9921959987b1b29d202cb507b.jpg"
                  alt="Representante IslaVende"
                  className="w-full h-full object-cover object-top rounded-2xl shadow-xl"
                />
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                ¿Cómo Funciona?
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-cobalt-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-lg">Regístrate Gratis</h3>
                    <p className="text-gray-600 text-sm">
                      Completa el formulario y recibe tu link único de representante en minutos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-cobalt-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-lg">Comparte Productos</h3>
                    <p className="text-gray-600 text-sm">
                      Usa tu link para compartir productos en redes sociales, WhatsApp o donde prefieras.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-cobalt-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1 text-lg">Gana Comisiones</h3>
                    <p className="text-gray-600 text-sm">
                      Por cada venta que generes, recibes hasta 10% de comisión directa a tu cuenta.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-cobalt-500 rounded-2xl p-8 sm:p-12 mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-white text-center">
              <div>
                <div className="text-5xl font-bold mb-2">10%</div>
                <p className="text-cobalt-100 text-sm">Comisión por venta</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">$0</div>
                <p className="text-cobalt-100 text-sm">Inversión inicial</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">24h</div>
                <p className="text-cobalt-100 text-sm">Aprobación rápida</p>
              </div>
            </div>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  Únete Ahora
                </h2>
                <p className="text-gray-600 text-base">
                  Completa el formulario y comienza a ganar comisiones hoy mismo
                </p>
              </div>

              <form onSubmit={handleSubmit} data-readdy-form id="registro-representantes">
                <div className="space-y-5">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Nombre Completo *
                    </label>
                    <input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      required
                      placeholder="Tu nombre completo"
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Correo Electrónico *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="tu@email.com"
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Teléfono *
                    </label>
                    <input
                      type="tel"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleChange}
                      required
                      placeholder="(787) 000-0000"
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Pueblo *
                    </label>
                    <input
                      type="text"
                      name="pueblo"
                      value={formData.pueblo}
                      onChange={handleChange}
                      required
                      placeholder="Tu pueblo en Puerto Rico"
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Experiencia en Ventas
                    </label>
                    <select
                      name="experiencia"
                      value={formData.experiencia}
                      onChange={handleChange}
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500 cursor-pointer"
                    >
                      <option value="">Selecciona una opción</option>
                      <option value="ninguna">Sin experiencia</option>
                      <option value="basica">Experiencia básica</option>
                      <option value="intermedia">Experiencia intermedia</option>
                      <option value="avanzada">Experiencia avanzada</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      ¿Por qué quieres ser representante?
                    </label>
                    <textarea
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={handleChange}
                      rows={4}
                      placeholder="Cuéntanos un poco sobre ti y tus objetivos..."
                      maxLength={500}
                      className="w-full px-4 py-3 text-sm border-2 border-gray-200 rounded-lg focus:outline-none focus:border-cobalt-500 resize-none"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
                  </div>

                  {submitStatus === 'success' && (
                    <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-500"></i>
                      <div>
                        <h4 className="font-semibold text-green-900 mb-1">¡Registro Exitoso!</h4>
                        <p className="text-sm text-green-700">
                          Hemos recibido tu solicitud. Te contactaremos en las próximas 24 horas con tu link de representante.
                        </p>
                      </div>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 flex items-start space-x-3">
                      <i className="ri-error-warning-fill text-2xl text-red-500"></i>
                      <div>
                        <h4 className="font-semibold text-red-900 mb-1">Error al enviar</h4>
                        <p className="text-sm text-red-700">
                          Hubo un problema al procesar tu solicitud. Por favor, intenta nuevamente.
                        </p>
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-4 bg-cobalt-500 text-white font-semibold rounded-xl hover:bg-cobalt-600 transition-colors shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Enviando...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-fill mr-2"></i>
                        Enviar Solicitud
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 sm:p-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              Preguntas Frecuentes
            </h2>

            <div className="space-y-6 max-w-3xl mx-auto">
              <div className="border-b border-gray-200 pb-6">
                <h4 className="font-semibold text-gray-900 mb-2 text-base">
                  ¿Cuánto puedo ganar como representante?
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Ganas hasta 10% de comisión por cada venta que generes. No hay límite de ganancias. Algunos de nuestros representantes más activos ganan más de $1,000 mensuales.
                </p>
              </div>

              <div className="border-b border-gray-200 pb-6">
                <h4 className="font-semibold text-gray-900 mb-2 text-base">
                  ¿Cuándo recibo mis comisiones?
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Las comisiones se pagan mensualmente mediante ATH Móvil o transferencia bancaria, 15 días después del cierre del mes.
                </p>
              </div>

              <div className="border-b border-gray-200 pb-6">
                <h4 className="font-semibold text-gray-900 mb-2 text-base">
                  ¿Necesito experiencia en ventas?
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  No es necesario. Te proporcionamos todo el material de apoyo y capacitación que necesitas para tener éxito.
                </p>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 mb-2 text-base">
                  ¿Hay algún costo para unirme?
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Absolutamente ninguno. El programa es 100% gratuito y sin compromisos. Solo necesitas ganas de compartir y ganar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RepresentantesPage;